import { render, staticRenderFns } from "./GameDiplomacyWarDeclared.vue?vue&type=template&id=99d52b1e&scoped=true&"
import script from "./GameDiplomacyWarDeclared.vue?vue&type=script&lang=js&"
export * from "./GameDiplomacyWarDeclared.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d52b1e",
  null
  
)

export default component.exports